import { ParseConsistentBase64JsonPayloadUseCase } from '../Utils/ParseConsistentBase64JsonPayload';
import { Result } from '@standardnotes/domain-core';
export class AsymmetricDecryptOwnMessage004 {
    constructor(crypto) {
        this.crypto = crypto;
        this.parseBase64Usecase = new ParseConsistentBase64JsonPayloadUseCase(this.crypto);
    }
    execute(dto) {
        const [_, nonce, ciphertext, additionalDataString] = dto.message.split(':');
        const additionalData = this.parseBase64Usecase.execute(additionalDataString);
        try {
            const plaintext = this.crypto.sodiumCryptoBoxEasyDecrypt(ciphertext, nonce, dto.recipientPublicKey, dto.ownPrivateKey);
            if (!plaintext) {
                return Result.fail('Could not decrypt message');
            }
            const signatureVerified = this.crypto.sodiumCryptoSignVerify(ciphertext, additionalData.signingData.signature, additionalData.signingData.publicKey);
            return Result.ok({
                plaintext,
                signatureVerified,
                signaturePublicKey: additionalData.signingData.publicKey,
                senderPublicKey: additionalData.senderPublicKey,
            });
        }
        catch {
            return Result.fail('Could not decrypt message');
        }
    }
}
